// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#SaleEdit_component .search_stock_number_container,
#WorkflowSaleEdit_component .search_stock_number_container {
  padding-top: 32px;
  justify-content: left;
}
#SaleEdit_component .workflow-edit-border,
#WorkflowSaleEdit_component .workflow-edit-border {
  border: 1px solid darkblue;
  margin: 10px;
  padding: 10px;
  width: 30% !important;
}
#SaleEdit_component .product-close-icon,
#WorkflowSaleEdit_component .product-close-icon {
  height: 35px;
  top: 50% !important;
}
#SaleEdit_component .form_group_diamond_location,
#WorkflowSaleEdit_component .form_group_diamond_location {
  padding: 10px;
  border: 1px solid gray;
  margin: 20px 0;
}
#SaleEdit_component .workflow-activity-card,
#WorkflowSaleEdit_component .workflow-activity-card {
  padding: 10px;
  border: 1px solid gray;
  margin: 20px 0;
}
#SaleEdit_component .workflow-activity-card .edit-link,
#WorkflowSaleEdit_component .workflow-activity-card .edit-link {
  cursor: pointer;
  color: #5673f8;
}
#SaleEdit_component .workflow-activity-subelement,
#WorkflowSaleEdit_component .workflow-activity-subelement {
  margin-left: 20px;
}
#SaleEdit_component .shipping-info-heading,
#WorkflowSaleEdit_component .shipping-info-heading {
  text-align: center;
}
#SaleEdit_component .sales-details-card,
#WorkflowSaleEdit_component .sales-details-card {
  background-color: white;
  margin-bottom: 10px;
  border-radius: 15px;
  padding-bottom: 10px;
}
#SaleEdit_component .sales-details-card h2,
#WorkflowSaleEdit_component .sales-details-card h2 {
  text-align: center !important;
  background-color: #727272;
  color: white;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  padding: 5px 15px;
  font-size: 18px;
}
#SaleEdit_component .sales-details-card .border-right,
#WorkflowSaleEdit_component .sales-details-card .border-right {
  border-right: 1px solid #ddd;
}
#SaleEdit_component .sales-details-card .border-right:last-child,
#WorkflowSaleEdit_component .sales-details-card .border-right:last-child {
  border-right: none;
}
#SaleEdit_component .btn-black,
#WorkflowSaleEdit_component .btn-black {
  background-color: #000 !important;
  border-color: #000 !important;
}
#SaleEdit_component .margin-top-32,
#WorkflowSaleEdit_component .margin-top-32 {
  margin: 32px auto;
}
#SaleEdit_component .center-element,
#WorkflowSaleEdit_component .center-element {
  display: flex;
  align-items: center;
  justify-content: center;
}
#SaleEdit_component td.cost-ready-not,
#WorkflowSaleEdit_component td.cost-ready-not {
  background: #fcdddb;
  color: red;
}
#SaleEdit_component td.cost-ready-yes,
#WorkflowSaleEdit_component td.cost-ready-yes {
  background: #89e689;
  color: #015001;
}
#SaleEdit_component td.text-align-end,
#WorkflowSaleEdit_component td.text-align-end {
  text-align: end;
}

#WorkflowSaleEdit_component .react-datepicker-wrapper {
  width: auto !important;
  width: initial !important;
}
#WorkflowSaleEdit_component .btn-remove {
  padding: 0px;
  display: block;
  height: 30px;
  width: 30px;
  border-radius: 50%;
  border: 1px solid black;
}

.modal .modal-90w {
  max-width: 70%;
  width: 70%;
}
@media all and (min-width: 0px) and (max-width: 600px) {
  .modal .modal-90w {
    margin: 0;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%) !important;
    max-height: 100%;
    max-width: 95%;
    width: 95%;
  }
}
.modal .modal-95w {
  max-width: 95%;
  width: 80%;
}
@media all and (min-width: 0px) and (max-width: 600px) {
  .modal .modal-95w {
    margin: 0;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%) !important;
    max-height: 100%;
    max-width: 95%;
    width: 95%;
  }
}

#SaleCostsEdit_component .hide {
  display: none;
}

hr.dashed {
  border-top: 2px dashed #999;
}

.dashed-right {
  border-right: 2px dashed #999;
  border-color: #c4c5cb;
}

hr.dotted {
  border-top: 2px dotted #999;
}

hr.solid {
  border-top: 2px solid #999;
}

hr.hr-text {
  position: relative;
  border: none;
  height: 1px;
  background: #999;
}

hr.hr-text::before {
  content: attr(data-content);
  display: inline-block;
  background: #fff;
  font-weight: bold;
  font-size: 0.85rem;
  color: #999;
  border-radius: 30rem;
  padding: 0.2rem 2rem;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}`, "",{"version":3,"sources":["webpack://./src/css/sales/sale_edit.scss"],"names":[],"mappings":"AAYE;;EACE,iBAAA;EACA,qBAAA;AAVJ;AAaE;;EACE,0BAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;AAVJ;AAaE;;EACE,YAAA;EACA,mBAAA;AAVJ;AAaE;;EACE,aAAA;EACA,sBAAA;EACA,cAAA;AAVJ;AAaE;;EACE,aAAA;EACA,sBAAA;EACA,cAAA;AAVJ;AAYI;;EACE,eAAA;EACA,cAAA;AATN;AAaE;;EACE,iBAAA;AAVJ;AAaE;;EACE,kBAAA;AAVJ;AAaE;;EACE,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,oBAAA;AAVJ;AAYI;;EACE,6BAAA;EACA,yBAAA;EACA,YAAA;EACA,4BAAA;EACA,6BAAA;EACA,iBAAA;EACA,eAAA;AATN;AAYI;;EACE,4BAAA;AATN;AAWM;;EACE,kBAAA;AARR;AAaE;;EACE,iCAAA;EACA,6BAAA;AAVJ;AAaE;;EACE,iBAAA;AAVJ;AAaE;;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AAVJ;AAaE;;EACE,mBAAA;EACA,UAAA;AAVJ;AAaE;;EACE,mBAAA;EACA,cAAA;AAVJ;AAaE;;EACE,eAAA;AAVJ;;AAeE;EACE,sBAAA;EAAA,yBAAA;AAZJ;AAeE;EACE,YAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,uBAAA;AAbJ;;AAkBE;EACE,cAAA;EACA,UAAA;AAfJ;AAiBI;EAJF;IAKI,SAAA;IACA,kBAAA;IACA,SAAA;IACA,QAAA;IACA,2CAAA;IACA,gBAAA;IACA,cAAA;IACA,UAAA;EAdJ;AACF;AAgBE;EACE,cAAA;EACA,UAAA;AAdJ;AAeI;EAHF;IAII,SAAA;IACA,kBAAA;IACA,SAAA;IACA,QAAA;IACA,2CAAA;IACA,gBAAA;IACA,cAAA;IACA,UAAA;EAZJ;AACF;;AAiBE;EACE,aAAA;AAdJ;;AAkBA;EACE,2BAAA;AAfF;;AAkBA;EACE,6BAAA;EACA,qBAhKW;AAiJb;;AAkBA;EACE,2BAAA;AAfF;;AAkBA;EACE,0BAAA;AAfF;;AAkBA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;AAfF;;AAkBA;EACE,2BAAA;EACA,qBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,oBAAA;EACA,oBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AAfF","sourcesContent":["$color_red_1: #ff9aa2;\n$color_red_2: #ffb7b2;\n$color_orange: #ffdac1;\n$color_grass: #e2f0cb;\n$color_green: #b5ead7;\n$color_purlple: #c7ceea;\n$blue_link: #5673f8;\n$font_size_content: 13px;\n$color_grey: #c4c5cb;\n\n#SaleEdit_component,\n#WorkflowSaleEdit_component {\n  .search_stock_number_container {\n    padding-top: 32px;\n    justify-content: left;\n  }\n\n  .workflow-edit-border {\n    border: 1px solid darkblue;\n    margin: 10px;\n    padding: 10px;\n    width: 30% !important;\n  }\n\n  .product-close-icon {\n    height: 35px;\n    top: 50% !important;\n  }\n\n  .form_group_diamond_location {\n    padding: 10px;\n    border: 1px solid gray;\n    margin: 20px 0;\n  }\n\n  .workflow-activity-card {\n    padding: 10px;\n    border: 1px solid gray;\n    margin: 20px 0;\n\n    .edit-link {\n      cursor: pointer;\n      color: #5673f8;\n    }\n  }\n\n  .workflow-activity-subelement {\n    margin-left: 20px;\n  }\n\n  .shipping-info-heading {\n    text-align: center;\n  }\n\n  .sales-details-card {\n    background-color: white;\n    margin-bottom: 10px;\n    border-radius: 15px;\n    padding-bottom: 10px;\n\n    h2 {\n      text-align: center !important;\n      background-color: #727272;\n      color: white;\n      border-top-left-radius: 15px;\n      border-top-right-radius: 15px;\n      padding: 5px 15px;\n      font-size: 18px;\n    }\n\n    .border-right {\n      border-right: 1px solid #ddd;\n\n      &:last-child {\n        border-right: none;\n      }\n    }\n  }\n\n  .btn-black {\n    background-color: #000 !important;\n    border-color: #000 !important;\n  }\n\n  .margin-top-32 {\n    margin: 32px auto;\n  }\n\n  .center-element {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  td.cost-ready-not {\n    background: #fcdddb;\n    color: red;\n  }\n\n  td.cost-ready-yes {\n    background: #89e689;\n    color: #015001;\n  }\n\n  td.text-align-end {\n    text-align: end;\n  }\n}\n\n#WorkflowSaleEdit_component {\n  .react-datepicker-wrapper {\n    width: unset !important;\n  }\n\n  .btn-remove {\n    padding: 0px;\n    display: block;\n    height: 30px;\n    width: 30px;\n    border-radius: 50%;\n    border: 1px solid black;\n  }\n}\n\n.modal {\n  .modal-90w {\n    max-width: 70%;\n    width: 70%;\n\n    @media all and (min-width: 0px) and (max-width: 600px) {\n      margin: 0;\n      position: absolute;\n      left: 50%;\n      top: 50%;\n      transform: translate(-50%, -50%) !important;\n      max-height: 100%;\n      max-width: 95%;\n      width: 95%;\n    }\n  }\n  .modal-95w {\n    max-width: 95%;\n    width: 80%;\n    @media all and (min-width: 0px) and (max-width: 600px) {\n      margin: 0;\n      position: absolute;\n      left: 50%;\n      top: 50%;\n      transform: translate(-50%, -50%) !important;\n      max-height: 100%;\n      max-width: 95%;\n      width: 95%;\n    }\n  }\n}\n\n#SaleCostsEdit_component {\n  .hide {\n    display: none;\n  }\n}\n\nhr.dashed {\n  border-top: 2px dashed #999;\n}\n\n.dashed-right {\n  border-right: 2px dashed #999;\n  border-color: $color_grey;\n}\n\nhr.dotted {\n  border-top: 2px dotted #999;\n}\n\nhr.solid {\n  border-top: 2px solid #999;\n}\n\nhr.hr-text {\n  position: relative;\n  border: none;\n  height: 1px;\n  background: #999;\n}\n\nhr.hr-text::before {\n  content: attr(data-content);\n  display: inline-block;\n  background: #fff;\n  font-weight: bold;\n  font-size: 0.85rem;\n  color: #999;\n  border-radius: 30rem;\n  padding: 0.2rem 2rem;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
